import { Flex, Icon, Input } from "@chakra-ui/react";
import { RiSearchLine } from "react-icons/ri";

export function SearchBox() {
  return (
    <Flex
      as="label"
      flex="1"
      py="4"
      px="7"
      ml={20}
      maxWidth={350}
      alignSelf="center"
      color="gray_light"
      position="relative"
      bg="gray"
      borderRadius="full"
      borderColor="gray"
      borderWidth={1}
    >
      <Input
        color="gray_light"
        variant="unstyled"
        px="0"
        mr="4"
        fontSize="lg"
        placeholder="Buscar na plataforma"
        _placeholder={{ color: "gray.300" }}
      />

      <Icon as={RiSearchLine} fontSize="20" />
    </Flex>
  );
}
